import { IDealRoomMenu } from '@app/interfaces/deal-room-menu';
import { handleHttpRequest } from './common.api';

const baseSlug = '/deal-room-menus';

export const createDealRoomMenu = async (payload: Partial<IDealRoomMenu>): Promise<IDealRoomMenu> => {
  return handleHttpRequest<IDealRoomMenu, Partial<IDealRoomMenu>>('post', `${baseSlug}`, payload);
};

export const updateDealRoomMenu = async (id: string, payload: Partial<IDealRoomMenu>): Promise<IDealRoomMenu> => {
  return handleHttpRequest<IDealRoomMenu, Partial<IDealRoomMenu>>('patch', `${baseSlug}/${id}`, payload);
};

export const deleteDealRoomMenu = async (id: string): Promise<undefined> => {
  return handleHttpRequest<undefined, undefined>('delete', `${baseSlug}/${id}`);
};

export const getDealRoomMenuByDealRoomId = async (dealRoomId: string): Promise<IDealRoomMenu[]> => {
  return handleHttpRequest<IDealRoomMenu[], undefined>('get', `${baseSlug}/dealRoom/${dealRoomId}`);
};

export const getDealRoom = async (id: string): Promise<IDealRoomMenu> => {
  return handleHttpRequest<IDealRoomMenu, undefined>('get', `${baseSlug}/${id}`);
};
